import EmbossInfo from './EmbossInfo';

export default EmbossInfo;